import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import useAdminApi from "@/hooks/useAdminApi";

const L = ({ label, children }) => (
  <label className="flex flex-col gap-1.5"><span className="eyebrow !text-[10px] text-[#6b6b6b]">{label}</span>{children}</label>
);

export default function SettingsTab() {
  const call = useAdminApi();
  const [f, setF] = useState(null);
  useEffect(() => {
    call("get", "/admin/settings").then(setF).catch((e) => toast.error(errMsg(e)));
  }, [call]);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      const { upi_id, payee_name, offer_active, offer_label, offer_percent } = f;
      setF(await call("put", "/admin/settings", { upi_id, payee_name, offer_active, offer_label, offer_percent: +offer_percent || 0 }));
      toast.success("Settings saved");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <form onSubmit={save} className="grid lg:grid-cols-2 gap-6" data-testid="admin-settings-form">
      <div className="bg-white border border-[#E2DCD0] p-6 space-y-4">
        <h3 className="text-2xl text-[#1E3B2E]">UPI payment</h3>
        <L label="UPI ID"><input className="field" placeholder="yourname@bank" value={f.upi_id} onChange={set("upi_id")} data-testid="admin-settings-upi-input" /></L>
        <L label="Payee name (as shown in UPI apps)"><input className="field" value={f.payee_name} onChange={set("payee_name")} data-testid="admin-settings-payee-input" /></L>
        <p className="text-xs text-[#6b6b6b]">The QR on the payment page is generated from this UPI ID with the exact booking amount.</p>
      </div>
      <div className="bg-white border border-[#E2DCD0] p-6 space-y-4">
        <h3 className="text-2xl text-[#1E3B2E]">Offer / discount</h3>
        <label className="flex items-center gap-3 text-sm"><input type="checkbox" className="accent-[#1E3B2E] h-4 w-4" checked={f.offer_active} onChange={set("offer_active")} data-testid="admin-settings-offer-active" />Offer active</label>
        <L label="Offer label (shown to guests)"><input className="field" placeholder="e.g. Direct booking offer" value={f.offer_label} onChange={set("offer_label")} data-testid="admin-settings-offer-label" /></L>
        <L label="Discount %"><input type="number" min={0} max={90} className="field" value={f.offer_percent} onChange={set("offer_percent")} data-testid="admin-settings-offer-percent" /></L>
      </div>
      <div className="lg:col-span-2"><button className="btn-primary" data-testid="admin-settings-save-btn">Save settings</button></div>
    </form>
  );
}
